import { useSingleton } from "../../other/injection";
import { RouteStore } from "../../other/navigationAndRouting/RouteStore";
import { BannerPage } from "../../uiLibrary/bannerPage/BannerPage";
import { BigRouteList } from "../../uiLibrary/bigRouteList/BigRouteList";
import { adminRoute } from "../../other/navigationAndRouting/routes";
import { observer } from "mobx-react-lite";

export const AdminPage = observer(() => {
    const routeStore = useSingleton(RouteStore);
    const routes = routeStore.getChildrenMenuRoutes(adminRoute);

    return (
        <BannerPage title="Admin">
            <BigRouteList routes={routes} testId="adminLinks" />
        </BannerPage>
    );
});
